<template>
  <el-dialog
    title="字段选择"
    v-dialogDrag
    :visible.sync="dialogVisible"
    class="large-dialog"
    append-to-body
    :close-on-click-modal="false"
  >
    <el-row class="h-full">
      <el-col :span="12" class="h-full">
        <div class="mr-10px h-full">
          <el-card class="h-full">
            <el-row class="mb-10px flex">
              <el-input
                placeholder="请输入"
                class="inline-block"
                prefix-icon="el-icon-search"
                v-model="treeKeyWords"
                clearable
              />
              <el-button type="primary" class="ml-6px" @click="searchTree">搜索</el-button>
            </el-row>
            <el-row class="tree-box">
              <el-tree
                highlight-current
                show-checkbox
                :data="treeData"
                v-loading="treeLoading"
                :props="defaultProps"
                ref="treeRef"
                node-key="id"
                :filter-node-method="treeFilterMethod"
                :default-checked-keys="defaultCheckedList"
                @check="checkNode"
                class="min-h-300px max-h-full overflow-auto"
              >
              </el-tree>
            </el-row>
          </el-card>
        </div>
      </el-col>
      <el-col :span="12" class="h-full">
        <div class="h-60px !leading-60px text-16px font-weight">
          <span>已选择：{{ selectedNodeList.length }}</span>
        </div>
        <div class="people-list overflow-auto">
          <div
            v-for="(nodeItem, index) in selectedNodeList"
            :key="nodeItem.id"
            class="flex mt-10px"
          >
            <span class="mr-10px iconfont icon-line-tree text-16px"></span>
            <span class="inline-block flex-1 mr-10px text-16px truncate">
              <span>{{ `${nodeItem.attributeName}` }}</span>
              <span class="mx-5px">-</span>
              <span class="text-12px">{{ `${nodeItem.className}` }}</span>
            </span>
            <span class="cursor-pointer text-16px" @click="deleteSelected(nodeItem, index)">X</span>
          </div>
        </div>
        <div class="mt-20px flex justify-center">
          <el-button type="primary" size="small" @click="saveSelected">保存</el-button>
          <el-button size="small" @click="dialogVisible = false">取消</el-button>
        </div>
      </el-col>
    </el-row>
  </el-dialog>
</template>

<script>
export default {
  name: 'storageDialog',
  props: {
    visible: {
      type: Boolean,
      default: false,
    }, // 弹窗显隐
    selectedList: {
      type: Array,
      default: () => {
        return []
      },
    }, // 默认已选中数据
    treeListData: {
      type: Array,
      default: () => {
        return []
      },
    }, // 目录树数据
    isSingleChoice: {
      type: Boolean,
      default: false,
    }, // 是否只能进行单选
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      },
    },
  },
  created() {
    this.defaultCheckedList = _.map(this.selectedList, 'attributeId')
    this.initCheckTree()
    this.treeData = [...this.treeListData]
    this.treeDataAddId(this.treeData)
    this.currentCheckedLength = this.selectedList.length
  },
  data() {
    return {
      treeKeyWords: '', // 目录树搜索关键字
      treeData: [], // 目录树数据
      treeLoading: false, // 目录树loading
      defaultProps: {
        children: 'attributeList',
        label: (data) => {
          if (data.attributeList) {
            return data.className
          }
          return data.attributeName
        },
        disabled: (data) => {
          return !!data.attributeList && this.isSingleChoice
        },
      }, // 目录树默认配置
      selectedNodeList: [], // 目录树已勾选节点
      defaultCheckedList: [], // 目录树默认勾选
      currentCheckedLength: 0, // 当前目录树选中节点个数
    }
  },
  methods: {
    /**
     * @description 目录树数据添加id属性
     * @param {Array} treeDataList 目录树列表数据
     * @param {String} classId 父级classId
     * @param {String} className 父级className
     */
    treeDataAddId(treeDataList, classId, className) {
      _.forEach(treeDataList, (treeItem) => {
        treeItem.id = treeItem.attributeList ? treeItem.classId : treeItem.attributeId
        if (!treeItem.classId) {
          treeItem.classId = classId
          treeItem.className = className
        }
        if (treeItem.attributeList) {
          this.treeDataAddId(treeItem.attributeList, treeItem.classId, treeItem.className)
        }
      })
    },

    /**
     * @description 初始化目录树默认勾选
     */
    initCheckTree() {
      this.selectedNodeList = [...this.selectedList]
    },

    /**
     * @description 目录树搜索
     */
    searchTree() {
      this.$refs.treeRef.filter(this.treeKeyWords)
    },

    /**
     * @description 目录树过滤
     */
    treeFilterMethod(value, data) {
      if (!value) return true
      return (
        (data.className && data.className.indexOf(value) !== -1) ||
        (data.attributeName && data.attributeName.indexOf(value) !== -1)
      )
    },

    /**
     * @description 目录树节点勾选
     */
    checkNode(currentData, checkedNode) {
      const isCheck = checkedNode.checkedKeys.length > this.currentCheckedLength
      this.checkTreeNode(currentData, isCheck)
      if (this.$refs.treeRef) {
        this.currentCheckedLength = this.$refs.treeRef.getCheckedKeys().length
      }
    },

    /**
     * @description 目录树节点勾选
     */
    checkTreeNode(currentData, isCheck) {
      if (currentData.attributeList) {
        _.forEach(currentData.attributeList, (childrenData) => {
          if (childrenData.attributeList) {
            this.checkTreeNode(childrenData, isCheck)
          } else {
            this.checkNodeChange(childrenData, isCheck)
          }
        })
        return
      }
      this.checkNodeChange(currentData, isCheck)
    },

    /**
     * @description 目录树节点勾选变化
     */
    checkNodeChange(data, isCheck) {
      if (isCheck) {
        if (this.isSingleChoice) {
          // 单选，先清空之前的勾选
          _.forEach(this.selectedNodeList, (item) => {
            this.$refs.treeRef && this.$refs.treeRef.setChecked(item.id, false)
          })
          this.selectedNodeList = []
        }
        // 勾选
        if (data.attributeList) return
        const findIndex = _.findIndex(this.selectedNodeList, (selectedItem) => {
          return selectedItem.id === data.id
        })
        if (findIndex === -1) {
          this.selectedNodeList.push({
            ...data,
          })
        }
      } else {
        // 取消勾选
        const findIndex = _.findIndex(this.selectedNodeList, (selectedItem) => {
          return selectedItem.id === data.id
        })
        if (findIndex !== -1) {
          this.selectedNodeList.splice(findIndex, 1)
        }
      }
    },

    /**
     * @description 前端记录选择项
     */
    saveSelected() {
      if (!this.selectedNodeList.length) {
        this.$message.warning('当前未选择数据')
        return
      }
      this.$emit('getSelectedList', [...this.selectedNodeList])
      this.dialogVisible = false
    },

    /**
     * @description 删除已勾选
     * @param {Object} deleteItem 删除项数据
     * @param {Number} deleteIndex 删除项序号
     */
    deleteSelected(deleteItem, deleteIndex) {
      this.selectedNodeList.splice(deleteIndex, 1)
      this.$refs.treeRef && this.$refs.treeRef.setChecked(deleteItem.id, false)
      if (this.$refs.treeRef) {
        this.currentCheckedLength = this.$refs.treeRef.getCheckedKeys().length
      }
    },
  },
}
</script>

<style lang="scss" scoped>

::v-deep .el-form-item__label {
  text-align: right;
}
::v-deep .el-card__body {
  height: 100%;
}
.people-list {
  height: calc(100% - 116px);
}
.tree-box {
  height: calc(100% - 46px);
}

</style>
